import { DeviceColumnConfig } from '@/types/table.types';
import { Device } from '@/types/device.types';
import {
  DeviceStatusCell,
  DeviceVehicleTypeCell,
  DeviceLastConnectionDateCell,
  DeviceLastOperationDateCell,
  DeviceLastConnectionZoneCell,
  DeviceLastOperationZoneCell,
  DeviceSerialNumberCell,
  DeviceAliasCell,
  DevicePlateCell,
} from '@/components/features/devices/tableCells';
import { TFunction } from 'i18next';
import { formatVehicleTypeForDisplay } from '@/config/deviceTypes.config';
import i18n from '@/i18n/i18n';

export const getDeviceTableColumns = (t: TFunction): DeviceColumnConfig[] => [
  {
    id: 'serialNumber',
    accessor: 'serialNumber',
    header: 'pages.devices.columns.serialNumber',
    enableSorting: true,
    enableFilter: true,
    filterType: 'select',
    cell: DeviceSerialNumberCell,
    textCase: 'uppercase',
  },
  {
    id: 'alias',
    accessor: 'alias',
    header: 'pages.devices.columns.alias',
    enableSorting: true,
    enableFilter: true,
    filterType: 'select',
    cell: DeviceAliasCell,
    textCase: 'uppercase',
  },
  {
    id: 'vehicle.plate',
    accessor: (row: Device) => row.vehicle.plate,
    header: 'pages.devices.columns.plate',
    enableSorting: true,
    enableFilter: true,
    filterType: 'select',
    cell: DevicePlateCell,
    textCase: 'uppercase',
  },
  {
    id: 'vehicle.type',
    accessor: (row: Device) => row.vehicle.type,
    header: 'pages.devices.columns.vehicleType',
    enableSorting: true,
    enableFilter: true,
    filterType: 'select',
    cell: DeviceVehicleTypeCell,
    getOptionLabel: (option: string) => {
      const currentLanguage = i18n.language === 'es' ? 'es' : 'en';
      return formatVehicleTypeForDisplay(option, currentLanguage as 'en' | 'es');
    },
  },
  {
    id: 'status',
    accessor: 'status',
    header: 'pages.devices.columns.status',
    enableSorting: true,
    enableFilter: true,
    filterType: 'select',
    cell: DeviceStatusCell,
    getOptionLabel: (option: string) => t(`status.${option.toLowerCase()}`),
  },
  {
    id: 'lastConnection',
    accessor: (row: Device) => row.lastConnection,
    header: 'pages.devices.columns.lastConnection',
    enableSorting: true,
    enableFilter: false,
    cell: DeviceLastConnectionDateCell,
  },
  {
    id: 'lastConnectionTz',
    accessor: (row: Device) => row.lastConnectionTz,
    header: 'pages.devices.columns.lastConnectionZone',
    enableSorting: false,
    enableFilter: false,
    cell: DeviceLastConnectionZoneCell,
  },
  {
    id: 'lastOperation',
    accessor: (row: Device) => row.lastOperation,
    header: 'pages.devices.columns.lastOperation',
    enableSorting: true,
    enableFilter: false,
    cell: DeviceLastOperationDateCell,
  },
  {
    id: 'lastOperationTz',
    accessor: (row: Device) => row.lastOperationTz,
    header: 'pages.devices.columns.lastOperationZone',
    enableSorting: false,
    enableFilter: false,
    cell: DeviceLastOperationZoneCell,
  },
];
